export default "__VITE_ASSET__db65f383__"